export default "__VITE_ASSET__29890c78__"